import { Joyride } from "react-joyride";
import { useOnboardingTour } from "./useOnboardingTour";
import OnboardingTooltip from "./OnboardingTooltip";
import { TOUR_DEPENDENCIES } from "./tourManifest";

// Drop-in per-page onboarding tour. Pages only need to:
//  1. tag target elements with data-tour="..."
//  2. render <OnboardingTour tourKey="..." steps={TOUR_STEPS.x} ready={...} />
// All tour state, persistence, sequencing, and styling logic lives in this
// module — pages don't need to know that e.g. "cases" waits on "sidebar".
export default function OnboardingTour({ tourKey, steps, ready = true }) {
  const { run, steps: liveSteps, onEvent } = useOnboardingTour(tourKey, steps, {
    ready,
    waitFor: TOUR_DEPENDENCIES[tourKey],
  });

  if (!steps || steps.length === 0) return null;

  return (
    <Joyride
      run={run}
      steps={liveSteps}
      continuous
      scrollToFirstStep
      onEvent={onEvent}
      tooltipComponent={OnboardingTooltip}
      options={{
        buttons: ["back", "skip", "primary"],
        skipBeacon: true,
        arrowColor: "#ffffff",
        overlayColor: "rgba(15, 23, 42, 0.5)",
        zIndex: 10000,
      }}
    />
  );
}
